import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
} from '@angular/core';
import { Constants } from 'src/app/models/Constants';
import { AlertEvent } from '../alert/models/alert-event';
import { AlertService } from '../alert/services/alert.service';
export interface PageTitleAction {
  label: string;
  primaryButton?: boolean;
  disabled?: boolean;
  isDisabled?: (input: any) => boolean;
  leftIcon?: string;
  rightIcon?: string;
  confirmIcon?: string;
  confirmMessage?: string;
  command: (input: any) => void;
}
@Component({
  selector: 'page-title',
  templateUrl: './page-title.component.html',
  styleUrls: ['./page-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageTitleComponent implements OnInit {
  @Input() public pageTitle = '';
  @Input() public subTitle = '';
  @Input() public createButtonVisible = false;
  @Input() public createButtonLabel = 'Manual Entry';
  @Input() public createButtonDisabled = false;
  @Input() public cancelButtonVisible = false;
  @Input() public cancelButtonLabel = 'Cancel';
  @Input() public exportButtonVisible = false;
  @Input() public exportDataLength = 0;
  @Input() public hasProjectedButtons = false;
  @Input() public pageTitleActions: PageTitleAction[] = [];
  @Input() public formValidityChange: EventEmitter<void> = new EventEmitter();
  @Output() emitExportType = new EventEmitter<string>();
  @Output() emitCreateButtonAction = new EventEmitter<any>();
  @Output() emitCancelButtonAction = new EventEmitter<any>();

  defaultExportKey = Constants.ExcelExportKey;

  constructor(
    private readonly alertService: AlertService,
    private readonly cdr: ChangeDetectorRef,
  ) {}
  ngOnInit(): void {
    // Listen for form validity changes
    if (this.formValidityChange) {
      this.formValidityChange.subscribe(() => {
        this.pageTitleActions = this.pageTitleActions.map((action) => {
          if (action.isDisabled) {
            action.disabled = !this.isActionDisabled(action);
          }
          return action;
        });
        this.cdr.detectChanges();
      });
    }
  }
  public exportItems = [
    {
      label: 'Excel',
      command: () => {
        this.OnClickExportButtonAction(Constants.ExcelExportKey);
      },
    },
    {
      label: 'CSV',
      command: () => {
        this.OnClickExportButtonAction(Constants.CsvExportKey);
      },
    },
  ];
  isActionDisabled(action: PageTitleAction): boolean {
    return action.isDisabled
      ? action.isDisabled(action)
      : action.disabled
        ? action.disabled
        : false;
  }
  OnClickCreateButtonAction() {
    this.emitCreateButtonAction.emit();
  }

  OnClickCancelButtonAction() {
    this.emitCancelButtonAction.emit();
  }

  OnClickExportButtonAction(exportType: string) {
    this.emitExportType.emit(exportType);
  }

  ConfirmAction(action: PageTitleAction) {
    let message = action.confirmMessage;
    const title = action.label;
    const img = `<img src="./assets/icons/${action.confirmIcon || 'warning.svg'}"> `;
    switch (action.label) {
      case 'Reset':
        message = 'Are you sure you want to reset to the original form?';
        break;
      case 'Cancel':
        message =
          'You are about to discard unsaved changes.<br><br>Do you want to proceed?';
        break;
      default:
        if (!action.confirmMessage) {
          action.command(action);
          return;
        }
    }
    const alertEvent: AlertEvent = {
      title: title,
      message: `${img}${message}`,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showCancelButton: true,
    };
    this.alertService.ConfirmThis(alertEvent, () => {
      action.command(action);
    });
  }
}
